<template lang="html">
  <div>
    <FullScreenSpinner v-if="fullScreenLoading" />
    <Header :currentMenu="currentMenu" :subMenu="subMenu" />
    <div :class='["dashboard-content-container", klass]'>
      <div class="flex-box page-container">
        <Menu :currentMenu="currentMenu" :subMenu="subMenu" class="desktop-only" />
        <div class="content">
          <div class="main-content">
            <slot></slot>
          </div>
          <FooterHelper />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullScreenSpinner from 'src/components/common/FullScreenSpinner.vue'
import Header from 'src/components/dashboard/shares/Header.vue'
import Menu from 'src/components/dashboard/shares/Menu.vue'
import FooterHelper from 'src/components/dashboard/shares/FooterHelper.vue'

export default {
  props: ["currentMenu", "subMenu", "klass", "fullScreenLoading"],
  components: {
    Header, Menu, FooterHelper, FullScreenSpinner
  }
}
</script>

<style lang="scss">
.main-content {
  min-height: calc(100vh - 285px);

  @media screen and (max-width: 768px) {
    min-height: calc(100vh - 245px);
  }

  @media screen and (max-width: 386px) {
    min-height: calc(100vh - 265px);
  }
}
</style>
